import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { SeismicDamageListDto } from '@cradua/data';
import Swal from 'sweetalert2';


@Component({
  selector: 'cradua-seismicdamagelist',
  templateUrl: './seismicdamagelist.component.html',
  styleUrls: ['./seismicdamagelist.component.scss']
})
export class SeismicDamageListComponent implements OnInit {


    seismicdamagelistForm: FormGroup;
    seismicdamagelistFormArray: FormGroup;
  control = new FormControl();
  @Input() seismicdamagelists: SeismicDamageListDto[];
  @Input() routeAnimationsElements: any;
  @Output() seismicdamagelist = new EventEmitter<SeismicDamageListDto[]>()
  @Output() deleteSeismicDamageListEvent = new EventEmitter<any>()

    selectedSeismicDamageList: any;
    filteredDelete: Array<any> =[];
    loading = true;
    selectedIndex = null;
    constructor(
     private fb: FormBuilder,
     ) {}

    ngOnInit() {
      this.createSeismicDamageListForm();
    }

    createSeismicDamageListForm() {
      this.seismicdamagelistForm = this.fb.group({
        ItemName: ['', Validators.required],
        OTPApprovedRate: [''],
        CompanyApprovedRate: [''],
        id: null
        });
        this.seismicdamagelistFormArray = this.fb.group({ SeismicDamageLists: this.fb.array([])
          });
          if(this.seismicdamagelists != null && this.seismicdamagelists.length) {
            this.setSeismicDamageList();
          }
        
    }

  // method to display seismicdamagelists
  setSeismicDamageList() {
    const control  = this.seismicdamagelistFormArray.controls.SeismicDamageLists as FormArray;
    this.seismicdamagelists.forEach( e => {
      control.push(
        this.fb.group({
          ItemName: e.ItemName,
          OTPApprovedRate: e.OTPApprovedRate,
          CompanyApprovedRate: e.CompanyApprovedRate,
          id: e.id
        })
      );
    });
  }


  // method to add seismicdamagelist
  addSeismicDamageList(value: SeismicDamageListDto) {
    const control  = this.seismicdamagelistFormArray.controls.SeismicDamageLists as FormArray;
    control.insert(0,
          this.fb.group({
            ItemName: value.ItemName,
            OTPApprovedRate: value.OTPApprovedRate,
            CompanyApprovedRate: value.CompanyApprovedRate,
            id: null
          })
       );
  }

  selectSeismicDamageList(value) {}

  // method to delete division from arrary list
  deleteSeismicDamageList(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it'
    }).then((result) => {
      if (result.value) {
  const control = this.seismicdamagelistFormArray.controls.SeismicDamageLists as FormArray;
  control.removeAt(index);
  for ( let i = 0; i < this.seismicdamagelists.length; i++) {
      if (i === index) {
        if (value.id !== null) {
          this.filteredDelete.push(this.seismicdamagelists[i].id);
         }

      }
    }
  Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire(
            'Cancelled',
            'Your imaginary file is safe :)',
            'error'
          );
        }
      });
  }

  addNew(formValue: SeismicDamageListDto) {
    if(this.seismicdamagelistForm.invalid) {
   return Swal.fire(
      'Warning!',
      'Please, you cannot add blank field',
      'warning'
    );
    }
    if(this.selectedIndex != null) {

      this.seismicdamagelistFormArray.get('SeismicDamageLists')['controls'][this.selectedIndex].patchValue({ItemName: formValue.ItemName, OTPApprovedRate: formValue.OTPApprovedRate, CompanyApprovedRate: formValue.CompanyApprovedRate});
    } else {
      this.addSeismicDamageList(formValue);
    }
    this.selectedIndex = null;
    this.seismicdamagelistForm.reset()
  }

  onEdit(index, value: SeismicDamageListDto) {
    console.log(index, value)
    this.selectedIndex = index;
    this.seismicdamagelistForm.patchValue({ItemName: value.ItemName, OTPApprovedRate: value.OTPApprovedRate, CompanyApprovedRate: value.CompanyApprovedRate});
  }

  onClearForm() {
    this.selectedIndex = null;
    this.seismicdamagelistForm.reset();
  }

  onSubmit(formValue: SeismicDamageListDto[]) {
  this.seismicdamagelist.emit(formValue);
  if(this.filteredDelete.length !== 0) {
    this.deleteSeismicDamageListEvent.emit(this.filteredDelete);
  }
  }

}
